import PayDiscrepancyScreen from "@/components/screens/PayDiscrepancyScreen";

export default function PayDiscrepancyPage() {
  return <PayDiscrepancyScreen />;
}
